import { render, staticRenderFns } from "./zijbalk.vue?vue&type=template&id=649093bc&scoped=true&"
import script from "./zijbalk.vue?vue&type=script&lang=js&"
export * from "./zijbalk.vue?vue&type=script&lang=js&"
import style0 from "./zijbalk.vue?vue&type=style&index=0&id=649093bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649093bc",
  null
  
)

export default component.exports